import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useTokens } from '../../component-themes';
import { forwardRef } from 'react';
import { accordionItemButtonTitleHeadline } from './styles/accordion-item-button-title-headline';
/**
 * Is used to display `AccordionItemButtonTitleHeadline` for `AccordionItemButtonTitle`.
 */
export const AccordionItemButtonTitleHeadline = forwardRef(({ as: Component = 'div', size, state, ...props }, ref) => {
    const tokens = useTokens();
    const styles = accordionItemButtonTitleHeadline(tokens)({
        size,
        state,
    });
    return _jsx(Component, { css: styles, ...props, ref: ref });
});
AccordionItemButtonTitleHeadline.displayName =
    'AccordionItemButtonTitleHeadline';
